import CreditCardsViewController from './CreditCardsViewController';

export default CreditCardsViewController;
